(() => {
  const root = document.querySelector('[data-boa-site]');
  if (!root) return;

  const cards = Array.from(root.querySelectorAll('[data-boa-product-id]'));
  const buttons = Array.from(root.querySelectorAll('[data-boa-filter]'));
  const status = root.querySelector('[data-boa-product-filter-status]');

  const showFilter = (filter) => {
    let visible = 0;
    cards.forEach((card) => {
      const categories = (card.dataset.boaCategory || '').split(/\s+/);
      const show = filter === 'all' || categories.includes(filter);
      card.hidden = !show;
      if (show) visible += 1;
    });
    buttons.forEach((button) => {
      const active = button.dataset.boaFilter === filter;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    if (status) status.textContent = `Showing ${visible} product${visible === 1 ? '' : 's'}.`;
  };

  buttons.forEach((button) => button.addEventListener('click', () => showFilter(button.dataset.boaFilter || 'all')));
  root.querySelectorAll('.boa-mobile-menu a').forEach((link) => link.addEventListener('click', () => link.closest('details')?.removeAttribute('open')));
})();
